module.exports = __webpack_public_path__ + "img/logo_CBF.1d7b1bbc.png";